/**
 * The strategies a derived row was scored from, read off its payload.
 *
 * Only confluence writes this, as `strategies: string[]` at
 * `packages/core/src/signals/hourly/confluence.ts:69`. It is the list that
 * turns "three or more strategies agreeing" from a fourth observation into a
 * summary of three rows already on the page.
 *
 * A reader rather than a field on `SignalView`, because the payload already
 * carries it and a second copy on the wire is a second thing to keep in step.
 * Anything that is not an array of strings gives `[]`; a row whose payload
 * disagrees with its type still renders, it just says nothing it cannot back.
 */
export function derivedVotes(payload: Record<string, unknown>): string[] {
  const strategies = payload.strategies;
  if (!Array.isArray(strategies)) return [];
  return strategies.filter((entry): entry is string => typeof entry === "string");
}

/**
 * Registry ids as words: `volume_breakout` reads "volume breakout".
 *
 * The same substitution `PriceChartLegend` makes for an unlabelled signal
 * type. Mapping ids to the catalogue's own labels would be better, and it
 * needs `@savi/core` on the web app's dependency list, which is a trade this
 * one tooltip does not justify.
 */
export function votesSentence(strategies: readonly string[]): string {
  return strategies.map((id) => id.replace(/_/g, " ")).join(", ");
}
